import { render, staticRenderFns } from "./QuestiongroupSeting.vue?vue&type=template&id=21f228b7&scoped=true"
import script from "./QuestiongroupSeting.vue?vue&type=script&lang=js"
export * from "./QuestiongroupSeting.vue?vue&type=script&lang=js"
import style0 from "./QuestiongroupSeting.vue?vue&type=style&index=0&id=21f228b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f228b7",
  null
  
)

export default component.exports